module.exports = __webpack_public_path__ + "logo.png?440768406de333518dcd190e40e94f78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eov/logo.png
// module id = 26
// module chunks = 0